// extracted by mini-css-extract-plugin
export default {"FooterMenu":"FooterMenu_FooterMenu__lAK4U","item":"FooterMenu_item__tTeiX","active":"FooterMenu_active__e8z8V"};